import React, { useCallback, useEffect, useState } from 'react'
import { BsFillFileEarmarkTextFill } from 'react-icons/bs'

import { documentsTranslate, pagesDesc } from '../../../i18n/translatedMessages'

import AccordionDocuments from './AccordionDocuments'
import DocfilesApi from '../../../API/Documents/Docfiles.api'
import Loading from '../../../Components/Loading/Loading'

import './employeeDocuments.sass'

const EmployeeDocuments = () => {
	const [documentsEmployee, setDocumentsEmployee] = useState(null)
	const [isLoading, setLoading] = useState(false)

	const loadEmployeeDocuments = useCallback(async () => {
		setLoading(true)
		setDocumentsEmployee(await DocfilesApi.getEmployeeDocfiles(JSON.parse(localStorage.getItem('user')).id))
		setLoading(false)
	}, [])

	useEffect(() => {
		loadEmployeeDocuments()
	}, [loadEmployeeDocuments])

	return (
		<div className='row EmployeeDocuments'>
			<div className='row header'>
				<div className='col d-flex mb-4'>
					<div className='icon'>
						<BsFillFileEarmarkTextFill size={30} />
					</div>
					<h1>{documentsTranslate.documentsTitle}</h1>
				</div>
			</div>
			<div>{pagesDesc.documentsDesc}</div>
			{isLoading ? (
				<Loading />
			) : documentsEmployee && documentsEmployee.length > 0 ? (
				<div className='mt-3'>
					<AccordionDocuments documents={documentsEmployee} loadEmployee={loadEmployeeDocuments} />
				</div>
			) : (
				<div className='p-4'>
					<div className='tw-mt-5 tw-w-full tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-rounded-md tw-text-gray-500'>
						{documentsTranslate.docNotRequested}
					</div>
				</div>
			)}
		</div>
	)
}

export default EmployeeDocuments
